import React, { useState } from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import InvoicedTab from '../components/invoicedTab';
import { Box, Chip } from '@mui/material';
import ReturnTab from '../components/returnTab';
import HeaderCatalogPageComponent from '../../../components/templates/headerCatalogPageUpdated';
import { useAppSelector } from '../../../store/hooks';
import { useNavigate } from 'react-router-dom';
var ContractSaleReturn = function () {
    var _a = useState("list"), activeView = _a[0], setActiveView = _a[1];
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    // const listVariants = ["Job Card Invoice", 'Job Card Invoice'];
    var listVariants = ["My contract sales return", "All contract sales return"];
    var navigate = useNavigate();
    var _b = useState(listVariants.length > 0 && isAllViewActive ? listVariants[0] : listVariants[1]), selectedListVariant = _b[0], setSelectedListVariant = _b[1];
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var handleCSRCreate = function () {
        navigate('/CSR-Create');
    };
    var formData = [{
            type: FormItemTypes.Tabs,
            name: 'Tabs',
            columnSize: 12,
            valueExpr: 'id',
            displayExpr: 'Name',
            tabs: [{
                    id: '01',
                    // Name: 'Invoiced',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Invoiced"), /*#__PURE__*/ React.createElement(Chip, {
                        label: "0",
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    element: InvoicedTab
                }, {
                    id: '02',
                    // Name: 'Returned',
                    Name: /*#__PURE__*/ React.createElement(Box, {
                        display: "flex",
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement("span", null, "Returned"), /*#__PURE__*/ React.createElement(Chip, {
                        label: "0",
                        color: "primary",
                        variant: "filled",
                        size: "small",
                        sx: {
                            marginLeft: 1
                        }
                    })),
                    element: ReturnTab
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        selectedMenuItem: selectedListVariant,
        menus: (listVariants === null || listVariants === void 0 ? void 0 : listVariants.length) > 0 ? listVariants : undefined,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        handleClickFilterIcon: handleCSRCreate
        // totalCount={getStockTransferList?.TotalCount}
        ,
        isCreateButton: false,
        title: "Job Card Invoice"
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
    }));
};
export default ContractSaleReturn;
